import { getIn } from 'fun-util';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import PopupConstants from '../PopupConstants';

export const DEFAULT_STATE = null;

const activePopup = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SelfServeBuilderEnum.SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS:
      if (getIn(action, 'data', 'custom_template', 'published_at')) {
        // If the document has been published, do not set an active popup
        return null;
      }
      return getIn(action, 'data', 'custom_template', 'field_outline', 'activePopup') || null;
    case PopupConstants.ACTIVE_POPUP_SET:
    case PopupConstants.CHANGE_POPUP:
    case PopupConstants.CREATE_POPUP:
    case PopupConstants.MOVE_POPUP:
      return action.id;
    case PopupConstants.CLEAR_ACTIVE_POPUP:
    case PopupConstants.DELETE_POPUP:
    case PopupConstants.DELETE_SHARE_POPUPS:
      return null;
    case PopupConstants.GROUP_POPUP_DELETE:
      return action.activeId;
    case PopupConstants.ACTIVATE_NEXT_UNFILLED_POPUP:
    case PopupConstants.POPUP_DIRECT_SELECT:
      return action.popup.id;
    default:
      return state;
  }
};

export default activePopup;



// WEBPACK FOOTER //
// ./src-react/Popups/PopupsReducer/activePopup.jsx